import { createContext } from 'react';

const AnnouncementContext = createContext();

export default AnnouncementContext;
